import nlp from 'compromise';
import sentencesExtensions from 'compromise-sentences';

nlp.extend(sentencesExtensions);

export const splitToParagraphs = (text) => {
  const sentences = nlp(text).sentences();
  const sentenceArr = sentences.list;
  const sentencesPerParagraph = 5;
  const wordsPerParagraph = 150;
  let wordCount = 0;
  let currentSentenceCount = 0;
  const paragraphSentences = sentences.list.reduce((acc, curr, i) => {
    wordCount += curr.length;
    currentSentenceCount += 1;
    // if (!(i % sentencesPerParagraph)) {
    if (wordCount > wordsPerParagraph || i === sentences.length - 1) {
      // if index is 0 or can be divided by the `size`...
      acc.push(sentenceArr.slice(i - currentSentenceCount + 1, i + 1)); // ..push a chunk of the original array to the accumulator
      currentSentenceCount = 0;
      wordCount = 0;
    }
    return acc;
  }, []);
  return paragraphSentences.map((sents) => sents.reduce((p, s) => p + s.text(), ''));
};

export const textReplacements = (text, replacementMap) => {
  // sort from shortest to longest to avoid sub-replacement
  const replacements = Object.keys(replacementMap).sort((a, b) => a.length - b.length);
  let newText = text;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < replacements.length; i++) {
    const find = replacements[i];
    const replace = replacementMap[find];
    newText = newText.replace(new RegExp(find, 'g'), replace);
  }
  return newText;
};
